import React from 'react';

import { Product } from 'types/state';
import { TableTr, TableTd } from 'design/table';
import { useIntlDictionary } from 'hooks/useIntlDictionary';

type Props = {
  item: Product;
  active: boolean;
  onClick(id: number): void;
};

export const ProductsTableRow = (props: Props) => {
  const { item, active, onClick } = props;

  const { shared: sharedDictionary } = useIntlDictionary();

  const onRowClick = React.useCallback(() => {
    onClick(item.id);
  }, [onClick, item.id]);

  const costValue = item.activeTariff
    ? sharedDictionary.moneyAmountText(item.activeTariff.cost, 'USD')
    : '-';

  return (
    <TableTr active={active} onClick={onRowClick}>
      <TableTd text={`${item.id}`} />
      <TableTd text={item.name} />
      <TableTd text={costValue} />
    </TableTr>
  );
};
